export enum AssignedUserType {
  primary = 'primary',
  backup = 'backup',
}
